module.exports = __webpack_public_path__ + "static/media/img-footernav--books.a8d1db07.png";